import { SET_ACCION } from '../constants/constants'

// eslint-disable-next-line default-param-last
const accion = (state = {}, action) => {
    if (action.type === SET_ACCION) {
        return action.payload
    }

    return state
}

export default accion
